// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37KBG","left":"styles_left__Mq_Tu"};